module.exports = __webpack_public_path__ + "static/media/CheckoutCustomIcons2.dbf0414f.png";